// Statische SEO-Blog-Artikel (Stub). Keine CMS-Anbindung – bewusst als Akquise-Content gepflegt.
export const blogPosts = [
  {
    slug: "dsgvo-einwilligung-physiotherapie",
    title: "DSGVO-konforme Einwilligung in der Physiotherapie: Was Praxen wissen müssen",
    excerpt:
      "Welche Anforderungen die DSGVO an die Erfassung von Patienteneinwilligungen stellt – und wie Sie diese in der Praxis rechtssicher und papierlos umsetzen.",
    date: "2026-05-12",
    readingMinutes: 6,
    tags: ["DSGVO", "Datenschutz", "Praxisorganisation"],
    body: [
      { h: "Warum die Einwilligung so wichtig ist" },
      {
        p: "Jede Physiotherapie-Praxis verarbeitet besonders schützenswerte Gesundheitsdaten nach Art. 9 DSGVO. Ohne eine wirksame, dokumentierte Einwilligung der Patient:innen drohen nicht nur Bußgelder, sondern auch ein Vertrauensverlust. Eine rechtssichere Einwilligung muss freiwillig, informiert, eindeutig und nachweisbar sein.",
      },
      { h: "Die vier Säulen einer wirksamen Einwilligung" },
      {
        p: "1. Transparenz: Patient:innen müssen verständlich erfahren, welche Daten zu welchem Zweck verarbeitet werden. 2. Freiwilligkeit: Keine Kopplung an die Behandlung, wo nicht erforderlich. 3. Nachweisbarkeit: Die Praxis muss belegen können, wann und wie die Einwilligung erteilt wurde. 4. Widerrufbarkeit: Der Widerruf muss so einfach sein wie die Erteilung.",
      },
      { h: "Papierlos statt Aktenordner" },
      {
        p: "Digitale Einwilligungen lösen das Problem der Nachweisbarkeit elegant: Zeitstempel, Versionierung der Datenschutzerklärung und eine verschlüsselt gespeicherte Unterschrift schaffen einen revisionssicheren Nachweis. Gleichzeitig sparen Sie Druck-, Scan- und Archivierungsaufwand.",
      },
      { h: "Aufbewahrung und Löschung" },
      {
        p: "Behandlungsunterlagen unterliegen einer Aufbewahrungsfrist von mindestens 10 Jahren (§ 630f BGB). Ein gutes System automatisiert die Fristenkontrolle und ermöglicht ein dokumentiertes Löschen nach Ablauf – sowie ein bevorzugtes Löschen auf Patientenwunsch nach Art. 17 DSGVO.",
      },
    ],
  },
  {
    slug: "patientenunterschrift-digital-tablet",
    title: "Digitale Patientenunterschrift am Tablet: Sicher, schnell, akzeptiert",
    excerpt:
      "Wie eine Canvas-Signatur am iPad funktioniert, warum sie rechtlich gültig ist und wie Sie biometrische Unterschriftsdaten DSGVO-konform schützen.",
    date: "2026-04-28",
    readingMinutes: 5,
    tags: ["Signatur", "iPad", "Sicherheit"],
    body: [
      { h: "Ist eine Unterschrift am Tablet rechtsgültig?" },
      {
        p: "Für die Einwilligung in die Datenverarbeitung genügt eine einfache elektronische Signatur. Eine handschriftliche Unterschrift auf dem Tablet-Display erfüllt diese Anforderung problemlos, sofern Identität und Zeitpunkt dokumentiert werden. Eine qualifizierte elektronische Signatur ist für diesen Zweck nicht erforderlich.",
      },
      { h: "Biometrische Daten besonders schützen" },
      {
        p: "Eine Unterschrift enthält biometrische Merkmale (Druck, Geschwindigkeit, Linienführung). Diese Daten sollten verschlüsselt gespeichert werden. In unserem System wird jede Signatur per AES-GCM mit einem praxisindividuellen Schlüssel verschlüsselt – ein Zugriff über Praxisgrenzen hinweg ist technisch ausgeschlossen.",
      },
      { h: "Reibungsloser Ablauf für Patient:innen" },
      {
        p: "Ein QR-Code am Empfang führt Patient:innen direkt in den mobiloptimierten Einwilligungsprozess. Daten eingeben, Datenschutzerklärung lesen, bestätigen, unterschreiben – fertig. Der Vorgang dauert weniger als zwei Minuten und endet mit einer automatisch erzeugten PDF.",
      },
    ],
  },
  {
    slug: "praxis-digitalisierung-erste-schritte",
    title: "Praxis-Digitalisierung: Die ersten Schritte zur papierlosen Aufnahme",
    excerpt:
      "Von der Patientenaufnahme bis zur Archivierung: ein praxisnaher Fahrplan, wie kleine und mittlere Praxen ohne IT-Abteilung digital werden.",
    date: "2026-04-10",
    readingMinutes: 7,
    tags: ["Digitalisierung", "Workflow", "Praxistipps"],
    body: [
      { h: "Klein anfangen, schnell Wirkung erzielen" },
      {
        p: "Die größte Hürde der Digitalisierung ist nicht die Technik, sondern der Einstieg. Beginnen Sie mit einem klar abgegrenzten Prozess: der Patientenaufnahme. Hier sparen Sie sofort Zeit und schaffen einen modernen ersten Eindruck.",
      },
      { h: "Multi-Mandantenfähigkeit für Praxisverbünde" },
      {
        p: "Betreiben Sie mehrere Standorte? Eine mandantenfähige Lösung trennt Daten strikt nach Praxis – inklusive eigener Datenschutztexte, Logos und Zugriffsrechte. So bleibt jede Praxis Herrin ihrer Daten, bei zentraler Verwaltung.",
      },
      { h: "Rollen und Rechte sauber abbilden" },
      {
        p: "Nicht jede Mitarbeiterin braucht Zugriff auf alles. Mit einem rollenbasierten Berechtigungskonzept (Empfang, Therapie, Praxisleitung) stellen Sie sicher, dass jeder nur das sieht, was er für seine Arbeit benötigt – ein Kernprinzip der DSGVO (Datenminimierung).",
      },
      { h: "Sicher in Deutschland gehostet" },
      {
        p: "Achten Sie auf den Serverstandort: Eine Datenhaltung in deutschen bzw. EU-Rechenzentren erfüllt die Anforderungen an Datenschutz und Datensouveränität. Kombiniert mit Verschlüsselung und Audit-Logs entsteht so eine belastbare Compliance-Grundlage.",
      },
    ],
  },
];

export const getPostBySlug = (slug) => blogPosts.find((p) => p.slug === slug);
